import { Button, VARIANTS } from 'shared';
import { ObjectValues } from 'types/common';

import { CoachSessionScheduleModal } from 'features/sessions/components/Modal/CoachSessionScheduleModal';
import { useNextSessionScheduleMutateOptions } from 'features/sessions/hooks/useNextSessionScheduleMutateOptions';
import { useParticipantCoachingMode } from 'features/sessions/hooks/useParticipantCoachingMode';
import { useRecentSprints } from 'features/sessions/hooks/useRecentSprints';
import { useUserId } from 'features/user/hooks/useUserId';

import { modal, SIZES } from 'shared/components/Modal';

type CoachSessionScheduleNextSessionButtonProps = {
  children: React.ReactNode;
  dataTestid?: string;
  icon?: React.ReactNode;
  fullWidth?: boolean;
  variant?: ObjectValues<typeof VARIANTS>;
  currentSessionId: string;
};

export const CoachSessionScheduleNextSessionButton = ({
  children,
  dataTestid,
  icon,
  fullWidth = true,
  currentSessionId,
}: CoachSessionScheduleNextSessionButtonProps) => {
  const userId = useUserId();
  const twoRecentSprints = useRecentSprints();
  const options = useNextSessionScheduleMutateOptions(currentSessionId);
  const coachingMode = useParticipantCoachingMode();

  const handleModalOpen = () => {
    modal.open({
      content: <CoachSessionScheduleModal key={userId} />,
      props: { size: SIZES.SM, title: 'Schedule session' },
      context: {
        sprints: twoRecentSprints,
        options,
        userId,
        previousSessionId: currentSessionId,
        coachingMode,
      },
    });
  };

  return (
    <Button
      data-testid={dataTestid}
      variant="outline"
      onClick={handleModalOpen}
      w={fullWidth ? 'full' : ''}
    >
      {icon} {children}
    </Button>
  );
};
